import { z } from 'zod'

const environmentNameSchema = z.enum(['local', 'dev', 'qa', 'tst', 'demo', 'uat', 'prod'])

const envSchema = z.object({
  VITE_ENVIRONMENT: environmentNameSchema,
  VITE_API_URL: z.string().min(1),
  VITE_ACCESS_CONTROL_API_URL: z.string().min(1).optional(),
  VITE_ENABLE_DEV_TOOLS: z.union([z.literal('TRUE'), z.literal('FALSE')]),
  VITE_TEST: z
    .union([z.literal('TRUE'), z.literal('FALSE')])
    .optional()
    .default('FALSE'),
  VITE_COGNITO_USER_POOL_ID: z.string().min(1),
  VITE_COGNITO_USER_POOL_CLIENT_ID: z.string().min(1),
  VITE_COGNITO_IDENTITY_POOL_ID: z.string().optional(),
  VITE_COGNITO_REGION: z.string().optional().default('us-west-1'),
  VITE_COGNITO_DOMAIN: z.string().min(1),
  VITE_COGNITO_SIGN_IN_URL: z.string().url(),
  VITE_COGNITO_SIGN_OUT_URL: z.string().url(),
})

export const env = envSchema.parse(import.meta.env)
